<template>
    <div class="noData" :style="{height: noDataHeight + 'px'}">
        <div class="imgBox"><img src="../../assets/images/public/notData.png"></div>
        <div class="text">{{$t('system.noData')}}</div>
    </div>
</template>
 
<script lang="ts">
import { computed, defineComponent, onMounted, reactive, toRefs, watch } from 'vue'
import i18n from "@/locales/index";
export default defineComponent({
    props: {
        noDataHeight: {
            type: Number,
            default: 695
        }
    },
    setup(props) {


    }
})

</script>
 
<style lang="scss" scoped>
.noData {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .imgBox {
        width: 40px;
        height: 40px;
    }

    .text {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.25);
    }
}
</style>